'use strict';

var _round = require('lodash/round');

var _round2 = _interopRequireDefault(_round);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseUtils = {
  parseBool: function parseBool(value) {
    if (typeof value === 'string') {
      value = value.toLowerCase();
    }
    switch (value) {
      case true:
      case 'true':
      case 1:
      case '1':
      case 'on':
      case 'yes':
        return true;
      default:
        return false;
    }
  },
  parseSize: function parseSize(value) {
    if (typeof value === 'number') {
      return (0, _round2.default)(value);
    }
    return 0;
  }

};

module.exports = parseUtils;